import React, { useState } from 'react';
import pb from '../../../lib/pocketbase';

const Profile = ({ user }) => {
    const [formData, setFormData] = useState({
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        phone: user?.phone || '',
        city: user?.city || '',
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    if (!user) return <div className="account-content-wrapper">Veuillez vous connecter.</div>;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ type: '', text: '' });
        try {
            const record = await pb.collection('users').update(user.id, {
                firstName: formData.firstName,
                lastName: formData.lastName,
                phone: formData.phone,
                city: formData.city,
                // Update full name for compatibility
                name: `${formData.firstName} ${formData.lastName}`.trim()
            });
            setMessage({ type: 'success', text: 'Profil mis à jour avec succès !' });
        } catch (err) {
            setMessage({ type: 'error', text: err.message || 'Erreur lors de la mise à jour' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="account-content-wrapper">
            <h2>Mon Profil</h2>

            {message.text && (
                <div className={`status-message ${message.type}`} style={{
                    padding: '1rem',
                    borderRadius: '0.75rem',
                    marginBottom: '1.5rem',
                    background: message.type === 'success' ? 'rgba(74, 222, 128, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                    color: message.type === 'success' ? '#4ade80' : '#ef4444',
                    border: `1px solid ${message.type === 'success' ? 'rgba(74, 222, 128, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`
                }}>
                    {message.text}
                </div>
            )}

            <div className="card" style={{ maxWidth: '600px', marginTop: '2rem' }}>
                <form className="settings-form" onSubmit={handleUpdateProfile}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                        <div className="form-group">
                            <label>Prénom</label>
                            <input
                                name="firstName"
                                type="text"
                                className="admin-input"
                                value={formData.firstName}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Nom</label>
                            <input
                                name="lastName"
                                type="text"
                                className="admin-input"
                                value={formData.lastName}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Email (non modifiable ici)</label>
                        <input
                            type="email"
                            className="admin-input"
                            value={formData.email}
                            disabled
                            style={{ opacity: 0.6 }}
                        />
                    </div>
                    <div className="form-group">
                        <label>Numéro de téléphone</label>
                        <input
                            name="phone"
                            type="tel"
                            className="admin-input"
                            placeholder="06 .. .. .. .."
                            value={formData.phone}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Ville</label>
                        <input
                            name="city"
                            type="text"
                            className="admin-input"
                            placeholder="Votre ville"
                            value={formData.city}
                            onChange={handleChange}
                        />
                    </div>
                    <button
                        type="submit"
                        className="primary-button"
                        style={{ marginTop: '1rem' }}
                        disabled={loading}
                    >
                        {loading ? 'Mise à jour...' : 'Enregistrer les modifications'}
                    </button>
                </form>
            </div>

            {/* Password section remains dummy or needs pb.collection('users').requestPasswordReset */}
            <div className="card" style={{ maxWidth: '600px', marginTop: '2rem', borderColor: 'rgba(239, 68, 68, 0.2)' }}>
                <h3>Mot de passe</h3>
                <p style={{ fontSize: '0.85rem', color: '#94a3b8', marginBottom: '1rem' }}>
                    Pour changer votre mot de passe, nous vous enverrons un lien de réinitialisation par email.
                </p>
                <button
                    className="secondary-button"
                    onClick={() => pb.collection('users').requestPasswordReset(user.email)}
                >
                    Envoyer le lien de réinitialisation
                </button>
            </div>
        </div>
    );
};

export default Profile;
